import React from "react"
import { arrayOf, string, number, func, bool, shape } from "prop-types"
import ThemeConsumer from "../ThemeConsumer"
import List from "./List"
import TypographLink from "../TypographLink/index"

const SuppressedList = ({
  theme,
  t,
  multicolumn,
  max,
  messageKey,
  emptyMessageKey,
  link,
  items,
  onClick,
  showLinkMoreItems = true
}) => {
  const hiddenItems = items.length - max

  if (!items.length) {
    return emptyMessageKey ? (
      <p className={theme.list}>{t(emptyMessageKey)}</p>
    ) : null
  }

  return (
    <List items={items.slice(0, max)} multicolumn={multicolumn} showTitle>
      {hiddenItems > 0 && showLinkMoreItems ? (
        <TypographLink
          size="small"
          weight="regular"
          preset="link"
          to={link}
          onClick={onClick}
          className={theme.moreItens}
        >
          {t(messageKey, { count: hiddenItems })}
        </TypographLink>
      ) : null}
    </List>
  )
}

SuppressedList.propTypes = {
  theme: shape({
    link: string
  }),
  items: arrayOf(string).isRequired,
  multicolumn: bool,
  max: number,
  messageKey: string,
  emptyMessageKey: string,
  t: func.isRequired,
  link: string,
  onClick: func,
  showLinkMoreItems: bool
}

SuppressedList.defaultProps = {
  theme: {},
  multicolumn: false,
  max: 0,
  messageKey: "",
  emptyMessageKey: "",
  link: ""
}

export default ThemeConsumer("UIList")(SuppressedList)



// WEBPACK FOOTER //
// ./src/shared/components/List/SuppressedList.js